import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ImageLinks from "../../assets/Images/ImagesLink";
import { Icon } from "leaflet";
import _ from "lodash";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import api_requests from "../../resources/api_requests";
import L from "leaflet";
import ProgressBar from "../../modules/ProgressBar";
import { useDispatch } from "react-redux";
import { hide_loader, show_loader } from "../../actions/app";
import OrderNotAssign from "../../modules/modals/OrderNotAssign";
import OrderCancelConfirm from "../../modules/modals/OrderCancelConfirm";
import moment from "moment";
import { useTranslation } from "react-i18next";

const icon_drop = new Icon({
  iconUrl: ImageLinks.drop,
  iconSize: [30, 30],
});
const icon_pick = new Icon({
  iconUrl: ImageLinks.pickup,
  iconSize: [30, 30],
});

const search_rider_Text = [
  "looking_for_nearest_rider",
  "assigning_rider_in_min",
  "riders_busy",
];

const pre_pickup_status = ["OUT_FOR_PICKUP", "CREATED", "REACHED_PICKUP"];

const SearchRider = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { order_id } = useParams();
  const [searchParams] = useSearchParams();
  const pending = searchParams.get("type");
  const [order_detail, set_order_detail] = useState(null);
  const [time_left, set_time_left] = useState(30);
  const [progress, set_progress] = useState(0);
  const [show_text_index, set_show_text_index] = useState(0);
  const [show_not_assign, set_show_not_assign] = useState(false);
  const [is_pending, set_is_pending] = useState(!_.isEmpty(pending));
  const [smart_allocation_config, set_smart_allocation_config] = useState();
  const [show_cancel_confirm_modal, set_show_cancel_confirm_modal] =
    useState(false);
  const location = useLocation();
  const { from } = location.state || {};
  const { t } = useTranslation();

  const interval_refs = useRef([]);
  useEffect(() => {
    if (is_pending) {
      get_smart_allocation_config();
    }
  }, [is_pending]);

  useEffect(() => {
    return () => {
      interval_refs.current
        .filter((id) => id !== undefined)
        .forEach(clearInterval);
      interval_refs.current = [];
    };
  }, []);

  useEffect(() => {
    let intervalId;
    if (!is_pending) {
      let elapsed_time = 0;
      let order_created_at = moment(order_detail?.created_at).add(2, "minutes");
      const current_time = moment();
      const isTimeExceeded = order_created_at.isBefore(current_time);
      if (isTimeExceeded) {
        set_show_text_index(2);
      } else {
        set_show_text_index(0);
        intervalId = setInterval(() => {
          set_show_text_index((prevIndex) => (prevIndex + 1) % 2);
        }, 3000);
      }
      // intervalId = setInterval(() => {
      //   set_show_text_index((prevIndex) => {
      //     if (isTimeExceeded) {
      //       return 2;
      //       // return (prevIndex + 1) % search_rider_Text.length;
      //     }
      //     return (prevIndex + 1) % 2;
      //   });
      //   // elapsed_time += 3;
      // }, 3000);
    }
    interval_refs.current.push(intervalId);
    return () => clearInterval(intervalId);
  }, [time_left, is_pending]);

  useEffect(() => {
    if (!is_pending) {
      start_count_down_timer();
      start_API_polling();
    }
  }, [is_pending]);

  useEffect(() => {
    set_progress(((30 - time_left) / 30) * 100);
  }, [time_left]);

  useEffect(() => {
    get_order_details(order_id);
  }, []);

  const start_count_down_timer = () => {
    let interval = setInterval(() => {
      set_time_left((prevTimeLeft) => {
        if (prevTimeLeft >= 10) {
          return prevTimeLeft - 1;
        } else {
          clearInterval(interval);
          return 0;
        }
      });
    }, 1000);
    interval_refs.current.push(interval);
  };

  const start_API_polling = () => {
    let api_interval = setInterval(async () => {
      try {
        const response = await api_requests.get_order_details(order_id);
        if (
          response?.data?.status === 1 &&
          _.isEmpty(response?.data?.fulfillment?.status)
        ) {
          interval_refs.current.forEach(clearInterval);
          interval_refs.current = [];
          set_show_not_assign(true);
          set_time_left(30);
          set_progress(0);
          set_show_text_index(0);
        }
        if (
          response?.data?.fulfillment?.status === "OUT_FOR_PICKUP" ||
          response?.data?.fulfillment?.status === "REACHED_PICKUP"
        ) {
          set_time_left(0);
          navigate(`/order-detail/${order_id}?from=search_rider`, {
            replace: true,
          });
        }
      } catch (error) {
        console.error("Error fetching API:", error);
      }
    }, 10000);

    interval_refs.current.push(api_interval);
  };

  const handle_back = () => {
    navigate("/dashboard");
  };

  const get_order_details = async (id) => {
    try {
      dispatch(show_loader());
      const response = await api_requests.get_order_details(id);
      if (response?.data?.cancelled) {
        navigate("/dashboard");
      }
      set_order_detail(response?.data);
      dispatch(hide_loader());
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const get_smart_allocation_config = async () => {
    try {
      const smart_config_business =
        await api_requests.get_smart_allocation_config_business();
      if (!_.isEmpty(smart_config_business)) {
        const filtered =
          _.filter(smart_config_business.data, (val) => {
            return val.order_process_type == 1 && val.default;
          })[0] || smart_config_business.data[0];
        set_smart_allocation_config(filtered);
      } else {
        const smart_config_parent =
          await api_requests.get_smart_allocation_config();
        set_smart_allocation_config(smart_config_parent.data);
      }
    } catch (error) {}
  };

  const handle_retry = async () => {
    const data = {
      ids: [order_id],
      fulfillment_type: 4,
      smart_allocation_id: smart_allocation_config?.id,
    };
    try {
      dispatch(show_loader());
      set_show_not_assign(false);
      const fulfillment = await api_requests.order_fullfillment(data);
      interval_refs.current.forEach(clearInterval);
      interval_refs.current = [];
      set_time_left(30);
      set_progress(0);
      set_show_text_index(0);
      if (is_pending) {
        set_is_pending(false);
      } else {
        start_count_down_timer();
        start_API_polling();
      }

      dispatch(hide_loader());
    } catch (err) {
      dispatch(hide_loader());
    }
  };

  const handle_cancel = () => {
    set_show_cancel_confirm_modal(true);
  };

  function FitBounds({ pickupCoord, dropCoord }) {
    const map = useMap();
    useEffect(() => {
      if (pickupCoord && dropCoord) {
        const bounds = L.latLngBounds([pickupCoord, dropCoord]);
        map.fitBounds(bounds);
      }
    }, [map, pickupCoord, dropCoord]);
    return null;
  }

  let marker1 = {};
  let marker2 = {};

  marker1 = {
    lat: order_detail?.sender_detail?.address?.latitude,
    lng: order_detail?.sender_detail?.address?.longitude,
  };
  marker2 = {
    lat: order_detail?.customer_detail?.address?.latitude,
    lng: order_detail?.customer_detail?.address?.longitude,
  };

  const upper_circle_class = useMemo(() => {
    return is_pending ? "ligth_yellow" : "pink";
  }, [is_pending]);

  const inner_circle_class = useMemo(() => {
    return is_pending ? "ligth_yellow" : "light_pink2";
  }, [is_pending]);

  const vertical_line_class = useMemo(() => {
    return is_pending ? "ligth_yellow" : "light_pink2";
  }, [is_pending]);

  const is_pre_pickup = useMemo(() => {
    return _.includes(
      pre_pickup_status,
      _.get(order_detail, "fulfillment.status", "-"),
    );
  }, [order_detail]);

  return (
    <>
      {order_detail && !order_detail?.cancelled && (
        <div className="h-screen flex flex-col">
          {/* Map Section */}
          <div className="flex-[0.7] relative">
            {order_detail &&
              marker1?.lat &&
              marker1?.lng &&
              marker2?.lat &&
              marker2?.lng && (
                <MapContainer
                  className="h-full w-full"
                  center={[marker1?.lat, marker1?.lng]}
                  zoom={15}
                  zoomControl={false}
                  scrollWheelZoom={false}
                  attributionControl={false}
                >
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                  />
                  <FitBounds
                    pickupCoord={[Number(marker1?.lat), Number(marker1?.lng)]}
                    dropCoord={[Number(marker2?.lat), Number(marker2?.lng)]}
                  />

                  <Marker
                    position={[marker1?.lat, marker1?.lng]}
                    icon={icon_pick}
                  />

                  <Marker
                    position={[marker2?.lat, marker2?.lng]}
                    icon={icon_drop}
                  />

                  <Polyline
                    positions={[
                      [marker1?.lat, marker1?.lng],
                      [marker2?.lat, marker2?.lng],
                    ]}
                    color="#8D027D"
                  />
                </MapContainer>
              )}
            {/* Back Button */}
            <div className="absolute top-5 left-5" style={{ zIndex: 400 }}>
              <img src={ImageLinks.home_icon} onClick={handle_back} />
            </div>
            {is_pre_pickup && (
              <div
                className="dropdown dropdown-bottom dropdown-end absolute top-5 right-5"
                style={{ zIndex: 400 }}
              >
                <img src={ImageLinks.menu_dots} tabIndex={0} role="button" />
                <ul
                  tabIndex={0}
                  className="dropdown-content menu bg-base-100 rounded-box z-[1] w-48 p-2 shadow"
                >
                  {/* <li>
                <div
                  className="flex flex-row"
                  onClick={() =>
                    navigate("/create-ticket", { state: { cdr_id: order_id } })
                  }
                  style={{ height: 36 }}
                >
                  <img src={ImageLinks.question_mark_circle} />
                  <p className="font-custom font-medium text-xs">Need Help?</p>
                </div>
              </li> */}
                  <li>
                    <div
                      className="flex flex-row"
                      onClick={handle_cancel}
                      style={{ height: 36 }}
                    >
                      <img src={ImageLinks.delete_red} />
                      <p className="font-custom font-medium text-xs text-error">
                        {t("cancel_order")}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>

          <div className="flex-[0.3] bg-white rounded-t-3xl p-4 shadow-lg">
            <div className="space-y-4">
              {!is_pending && (
                <>
                  <div className="flex">
                    <div className="flex gap-4">
                      <img src={ImageLinks.motor_racing_helmet} />
                      <div className="flex flex-col">
                        <p className="text-sm text-dark_black font-custom font-semibold">
                          {t(search_rider_Text[show_text_index])}
                        </p>
                        <p className="text-[10px] text-dark_gray font-custom font-semibold">
                          {t("wait_assigning_rider")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="px-7">
                    <ProgressBar progress={progress} />
                  </div>
                </>
              )}
              {is_pending && (
                <div
                  className={`bg-ligth_yellow flex items-center justify-center rounded-lg mb-4 py-[10px]`}
                >
                  <p
                    className={`font-custom font-medium text-xs text-[#F2C16B]`}
                  >
                    {t("order_not_assigned")}
                  </p>
                </div>
              )}
              <div className="flex flex-col items-start w-full pr-2">
                <ul className="timeline timeline-vertical w-full">
                  <li className="relative flex pb-5">
                    <div
                      className={`absolute left-1 top-2 h-full w-px bg-${vertical_line_class}`}
                    ></div>
                    <div
                      className={`absolute top-1 h-2 w-2 rounded-full bg-${upper_circle_class}`}
                    ></div>

                    <div className="pl-5 w-full">
                      <div>
                        <p className="line-clamp-1 font-bold text-sm font-custom text-dark_black">
                          {order_detail?.sender_detail?.address?.address_line_1}
                        </p>
                        <p className="line-clamp-2 text-[10px] text-dark_gray font-custom font-semibold">
                          {order_detail?.sender_detail?.address.address_line_2}
                        </p>
                        <p className="text-[10px] text-dark_gray font-custom font-semibold">
                          {order_detail?.sender_detail?.name}{" "}
                          <span className="mx-2">|</span>
                          {order_detail?.sender_detail?.mobile}
                        </p>
                      </div>
                    </div>
                  </li>

                  <li className="relative flex">
                    <div
                      className={`absolute top-1 h-2 w-2 rounded-full bg-${inner_circle_class}`}
                    ></div>

                    <div className="pl-5 w-full">
                      <div>
                        <p className="line-clamp-1 font-bold text-sm font-custom text-dark_black">
                          {
                            order_detail?.customer_detail?.address
                              ?.address_line_1
                          }
                        </p>
                        <p className=" line-clamp-1 text-[10px] text-dark_gray font-custom font-semibold">
                          {
                            order_detail?.customer_detail?.address
                              .address_line_2
                          }
                        </p>
                        <p className="text-[10px] text-dark_gray font-custom font-semibold">
                          {order_detail?.customer_detail?.name}
                          <span className="mx-2">|</span>
                          {order_detail?.customer_detail?.mobile}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              {is_pending && (
                <div className="mt-8 px-6">
                  <button
                    onClick={handle_retry}
                    // disabled={btn_disable}
                    className="font-custom btn btn-block bg-primary text-white cursor-not-allowed rounded-[30px] text-base font-semibold"
                  >
                    {t("try_again")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {order_detail && !order_detail?.cancelled && show_not_assign && (
        <OrderNotAssign handle_retry={handle_retry} />
      )}
      {order_detail &&
        !order_detail?.cancelled &&
        show_cancel_confirm_modal && (
          <OrderCancelConfirm
            close={() => set_show_cancel_confirm_modal(false)}
            order_id={order_id}
            title={t("want_to_cancel")}
            sub_title={t("confirm_for_cancel")}
            condition={""}
            from={from}
          />
        )}
    </>
  );
};

export default SearchRider;
